module.exports = __webpack_public_path__ + "static/img/coin_3.c250f6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/tideng/anniversary/guide/coin_3.png
// module id = Ctx9
// module chunks = 4